import WalletOperationDetailModal from './WalletOperationDetailModal';

export default WalletOperationDetailModal;
